export default __webpack_public_path__ + "static/media/FlowerFam—gifs.10034366.gif";